<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefresh">{{generateCustomizeString('refresh')}}</el-button>
          <el-button round @click="onCreatePlan">{{generateCustomizeString('add')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="planlist">
      <div class="card-list">
        <el-card class="box-card" v-for="(plan, index) in plans" :key="plan.id">
          <div slot="header" class="header">
            <el-input
              :disabled="!plan.isEdit"
              placeholder="Please input"
              size="mini"
              style="max-width: 120px"
              v-model="plan.name"></el-input>
            <div v-if="!plan.isEdit">
              <el-button class="header-button" @click="onEdit(index)" type="text">{{generateCustomizeString('edit')}}</el-button>
              <el-button class="header-button" @click="onDelete(index)" type="text">{{generateCustomizeString('delete')}}</el-button>
            </div>
            <div v-else>
              <el-button class="header-button" @click="onSave(index)" type="text">{{generateCustomizeString('save')}}</el-button>
              <el-button class="header-button" @click="onCancel(index)" type="text">{{generateCustomizeString('cancel')}}</el-button>
            </div>
          </div>
          <el-table
            :data="plan.level_discounts"
            :default-sort = "{prop: 'level', order: 'descending'}"
            :show-header = "false"
            style="width: 200px">
            <el-table-column
              prop="level"
              label="level"
              width="100">
              <template slot-scope="scope">
                <el-tag :disable-transitions="true"
                        size="mini"
                        v-if="$i18n.locale == 'zh'">
                  {{scope.row.level_item.name}}
                </el-tag>
                <el-tag :disable-transitions="true"
                        size="mini"
                        v-if="$i18n.locale == 'en'">
                  {{scope.row.level_item.enName}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="discount"
              label="discount"
              width="100">
              <template slot-scope="scope" >
                <el-input
                  :disabled="!plan.isEdit"
                  placeholder="Please input"
                  size="mini"
                  v-model="scope.row.discount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </el-main>
    <el-dialog title="提示" :visible.sync="removePlanDialogVisible" width="30%" :append-to-body="true">
      <span>{{ generateCustomizeString('confirmDelete') }}</span>
      <span slot="footer" class="dialog-footer">
                <el-button @click="removePlanDialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
                <el-button type="primary" @click="onConfirmDelete()">{{ generateCustomizeString('confirm') }}</el-button>
              </span>
    </el-dialog>
    <el-dialog :title="generateCustomizeString('createPlan')" :visible.sync="createDialogVisiable" width="40%" :append-to-body="true">
      <el-form ref="form" :model="form" :rules="rules" label-width="30%" class="detailForm">
        <el-form-item :label="generateCustomizeString('createDiscountPlan')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onConfirmCreatePlan">{{generateCustomizeString('create')}}</el-button>
          <el-button @click="onCancelCreate">{{generateCustomizeString('cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import { deepCopy, checkNumber } from '@/utils/helper'

export default {
  name: 'DiscountPlanList',
  data() {
    return {
      plans: [],
      isEdit: false,
      originPlans: [],
      removePlanDialogVisible: false,
      willDeletePlanId: null,
      createDialogVisiable: false,
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 64,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      },
      form: {
        name: ''
      }
    }
  },
  methods: {
    generateCustomizeString,
    onCreatePlan() {
      this.createDialogVisiable = true
    },
    onConfirmCreatePlan() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.fetchAddPlan(this.form)
        } else {
          this.$message.error(this.generateCustomizeString('dataError'))
        }
      })
    },
    onCancelCreate() {
      this.$refs.form.resetFields()
      this.createDialogVisiable = false
    },
    onRefresh() {
      this.fetchAllPlans()
    },
    onEdit(index) {
      this.$set(this.plans[index], `isEdit`, true)
    },
    onCancel(index) {
      this.plans = deepCopy(this.originPlans)
      this.$set(this.plans[index], `isEdit`, false)
    },
    onDelete(index) {
      const plan = this.plans[index]
      this.willDeletePlanId = plan.id
      this.removePlanDialogVisible = true
    },
    onConfirmDelete() {
      if (this.willDeletePlanId) {
        this.fetchDeletePlan(this.willDeletePlanId)
      }
    },
    onSave(index) {
      this.$set(this.plans[index], `isEdit`, false)

      const discountMap = []
      this.originPlans[index].level_discounts.map(levelDiscount => {
        discountMap[levelDiscount.level] = levelDiscount.discount
      })

      const originPlan = this.originPlans[index]
      const plan = this.plans[index]
      const editDiscounts = plan.level_discounts.filter(levelDiscount => {
        const discount = discountMap[levelDiscount.level]
        if (discount === levelDiscount.discount) {
          return false
        }
        return true
      })

      for (var lDiscount of editDiscounts) {
        if (!checkNumber(lDiscount.discount) ||
            lDiscount.discount < 0 ||
            lDiscount.discount > 1) {
          this.$set(this.plans[index], `isEdit`, true)
          this.$message.error(this.generateCustomizeString('pleaseEnter'))
          return
        }
      }

      if (editDiscounts.length > 0 || originPlan.name !== plan.name) {
        this.fetchUpdatePlan(plan.id, plan.name, editDiscounts.map(levelDiscount => {
          var lDisount = {}
          lDisount.level = levelDiscount.level
          lDisount.discount = levelDiscount.discount
          return lDisount
        }))
      }
    },
    fetchAllPlans() {
      request({
        url: 'discount/plan/list',
        method: 'get'
      }).then(response => {
        this.originPlans = response.data.map(plan => {
          plan.isEdit = false
          return plan
        })
        this.plans = deepCopy(this.originPlans)
        for (var i = 0; i < this.plans.length; i++) {
          for (var j = 0; j < this.plans[i].level_discounts.length; j++) {
            switch (this.plans[i].level_discounts[j].level_item.name) {
              case '青铜':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('青铜')
                break
              case '白银':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('白银')
                break
              case '黄金':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('黄金')
                break
              case '铂金':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('铂金')
                break
              case '钻石':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('钻石')
                break
              case '星耀':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('星耀')
                break
              case '王者':
                this.plans[i].level_discounts[j].level_item.enName = this.generateCustomizeString('王者')
                break
              default:
                this.plans[i].level_discounts[j].level_item.enName = this.plans[i].level_discounts[j].level_item.name
            }
          }
        }
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
      })
    },
    fetchUpdatePlan(planId, name, levelDiscounts) {
      request({
        url: `discount/plan/${planId}`,
        method: 'patch',
        data: {
          'level_discounts': levelDiscounts,
          'name': name || ''
        }
      }).then(response => {
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
      })
    },
    fetchDeletePlan(planId) {
      request({
        url: `discount/plan/${planId}`,
        method: 'delete'
      }).then(response => {
        this.willDeletePlanId = null
        this.removePlanDialogVisible = false
        if (response.status === 60020) {
          let goodsStr = ''
          for (var i = response.data.length - 1; i >= 0; i--) {
            goodsStr += response.data[i]['product_name'] + '<br/>'
          }
          this.$alert(goodsStr, response.error, {
            confirmButtonText: this.generateCustomizeString('confirm'),
            dangerouslyUseHTMLString: true
          })
        } else {
          this.fetchAllPlans()
        }
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
      })
    },
    fetchAddPlan(data) {
      if (this.createLoading) return
      this.createLoading = true
      request({
        url: 'discount/plan',
        method: 'post',
        data
      }).then(response => {
        this.$refs.form.resetFields()
        this.createDialogVisiable = false
        this.$message.success(this.generateCustomizeString('createdSuccessfully'))
        this.fetchAllPlans()
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.createLoading = false
      })
    }
  },
  created() {
    this.fetchAllPlans()
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta && to.meta.badge) {
      to.meta.badge = null
    }
    next()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #eee;
    color: #333;
  }
  .header-button {
    padding: 0px !important;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .box-card {
    width: 250px;
    margin-bottom: 20px;
    margin-right: 15px;
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  .planlist {
    .el-input__inner{
      color: #666 !important;
    }
    .el-table td, .el-table th {
      padding: 2px 0 !important;
    }
    .el-table td, .el-table th.is-leaf {
      border-bottom: 0px;
    }
    .el-table::before {
      color: unset;
    }
  }
</style>
